exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-group[data-v-1379f496]{width:100%;display:flex;justify-content:flex-end}.button-group button svg+span[data-v-1379f496]{margin-left:.625rem}.button-group button[data-v-1379f496]:last-of-type{margin-left:1rem}.button-group.marginBottom[data-v-1379f496]{margin-bottom:2.5rem}.row-label .remove[data-v-1379f496]{cursor:pointer;color:#16244f;font-size:.875rem;position:relative;margin-left:.375rem}", ""]);

// exports
